export default {
  init() {
    // JavaScript to be fired on all pages

    // resize form based on sidebar height
    if ($('form.checkout').length && $('.sidebar-lg-sticky').length) {
      $(window).on('load resize', function () {
        if ($(window).width() >= 1025) {
          $('form.checkout').css('min-height', $('.sidebar-lg-sticky').height());
        } else {
          $('form.checkout').css('min-height', '');
        }
      });
    }

    // $(document.body).on('update_checkout', function () { ... });
    
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/checkout.js